import type { ReactNode } from 'react';

import { ForbiddenView } from '../shell/ForbiddenView';
import { satisfiesAny, useRoles, type AdminRole } from './roles';

/**
 * Role gate (admin-shell-oidc-rbac §4.3): renders children only if the user's
 * roles satisfy ANY of `anyOf` under the admin hierarchy (an `admin` clears an
 * `operator`/`viewer` requirement). Otherwise shows the 403 forbidden view.
 * UX gating only — the service re-enforces RBAC on every call.
 */
export function RequireRole({
  anyOf,
  children,
}: {
  anyOf: readonly AdminRole[];
  children: ReactNode;
}) {
  const held = useRoles();
  if (!satisfiesAny(held, anyOf)) {
    return <ForbiddenView requiredRoles={anyOf} held={held} />;
  }
  return <>{children}</>;
}
